import { Emprendedor, Event, AdminUser, EmprendedorUser } from '../types';

export const mockEmprendedores: Emprendedor[] = [
  {
    id: "e1",
    brandName: "Kreativa Manualidades",
    logoUrl: "https://via.placeholder.com/150/FFC0CB/000000?text=K",
    description: "Arte y detalles hechos con amor.",
    social: { instagram: "@kreativa" }
  },
  {
    id: "e2",
    brandName: "Sabor Local Café",
    logoUrl: "https://via.placeholder.com/150/D2B48C/000000?text=S",
    description: "Café de origen de la sierra.",
    social: { instagram: "@saborlocal" }
  },
  {
    id: "e3",
    brandName: "Eco Textiles",
    logoUrl: "https://via.placeholder.com/150/90EE90/000000?text=E",
    description: "Moda sostenible y consciente.",
    social: { instagram: "@ecotextiles" }
  },
];

export const mockEvents: Event[] = [
  {
    id: "evt-001",
    name: "Feria de Madres (CC Viva)",
    location: "Centro Comercial Viva",
    startDate: "2025-05-10",
    endDate: "2025-05-12",
    bannerImg: "https://quindio.gov.co/medios/9_de_mayo/nota_feria.jpeg",
    description: "El evento perfecto para encontrar el regalo de mamá.",
    participants: ["e1", "e2"],
    stands: [
      { id: "s1", type: "Stand Pequeño (2x2m)", price: 350000, available: 5, total: 20 },
      { id: "s2", type: "Stand Esquinero (3x2m)", price: 500000, available: 1, total: 5 }
    ]
  },
  {
    id: "evt-002",
    name: "Navidad en la Feria (Parque Central)",
    location: "Parque Central",
    startDate: "2025-12-01",
    endDate: "2025-12-05",
    bannerImg: "https://www.radioimagina.cl/wp-content/uploads/2024/12/Feria-Navidena.jpg",
    description: "Encuentra todos tus regalos y vive la magia.",
    participants: ["e1"],
    stands: [
      { id: "s3", type: "Isla Central", price: 800000, available: 0, total: 2 },
      { id: "s4", type: "Stand Regular (2x2m)", price: 400000, available: 15, total: 30 }
    ]
  },
  {
    id: "evt-003",
    name: "Feria de Emprendimiento Juvenil",
    location: "Universidad Nacional",
    startDate: "2025-08-15",
    endDate: "2025-08-17",
    bannerImg: "https://www.uaa.mx/portal/wp-content/uploads/2025/05/Emprendimient-3-1024x683.jpg",
    description: "Espacio para jóvenes emprendedores con ideas innovadoras.",
    participants: ["e2", "e3"],
    stands: [
      { id: "s5", type: "Stand Básico (2x2m)", price: 250000, available: 10, total: 25 },
      { id: "s6", type: "Stand Premium (3x3m)", price: 600000, available: 3, total: 8 }
    ]
  }
];

export const mockAdminUser: AdminUser = {
  id: "admin-01",
  name: "Wilson Sierra",
  email: "wilson@zonnain.com",
  role: "admin"
};

export const mockEmprendedorUser: EmprendedorUser = {
  id: "e1",
  name: "Ana Gómez",
  email: "ana@kreativa.com",
  role: "emprendedor",
  profile: mockEmprendedores[0]
};
